<template>
    <v-container fluid>
        <p>روش تماس</p>
        <v-radio-group v-model="radios" row>
            <v-radio label="تماس امن" value="secure_call"></v-radio>

            <v-radio label="تماس مستقیم" value="direct_call"></v-radio>

            <v-radio label="غیرفعال" value="hide_phone"></v-radio>
        </v-radio-group>
    </v-container>
</template>

<script>
export default {
    name: "callMethod",
    data() {
        return {
            radios: 'secure_call',
        }
    },
    watch: {
        radios: {
            immediate: true,
            handler(value) {
                this.$emit("input", value);
            }
        }
    }
}
</script>

<style scoped>

</style>